import React from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { AutocompleteListItem } from "models/propTypes/listPropTypes";
//#endregion
//#region components
import AddPaymentMethodFormContainer from "../../forms/addPaymentMethodFormContainer";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import { OTHER_PAYMENT_METHOD_ID } from "utils/constants/receiptConstants";

function usePaymentMethods(receipt: WintSuperkollAPIModel.Receipt) {
  const allReceiptPaymentMethods = useSelector((state: AppState) => state.auth.selectedCompany.receiptPaymentMethods);
  const loggedInUserReceiptPaymentMethods = useSelector((state: AppState) => state.auth.loggedInUser.paymentMethods);

  const loggedInUserId = useSelector((x: AppState) => x.auth.loggedInUser.personId ?? 0);

  const isOtherPaymentMethod = receipt.isOtherPaymentMethod ?? false;

  const receiptPaymentMethods = React.useMemo((): AutocompleteListItem[] => {
    const methods =
      receipt.createdByPersonId === loggedInUserId
        ? loggedInUserReceiptPaymentMethods
        : receipt.createdByPersonId !== undefined && allReceiptPaymentMethods
          ? (allReceiptPaymentMethods[receipt.createdByPersonId] ?? [])
          : [];

    const mapped = methods
      ?.filter((pm) => !pm.isPaymentMethodTypeDisabled)
      .map((item) => ({
        id: item.id,
        value: item.name ?? " ",
        data: item,
      }));

    if (isOtherPaymentMethod) {
      mapped.push({
        id: OTHER_PAYMENT_METHOD_ID,
        value: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Other),
        data: {
          id: OTHER_PAYMENT_METHOD_ID,
          name: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Other),
        } as unknown as WintSuperkollAPIModel.ReceiptPaymentMethod,
      });
    }
    return mapped;
  }, [receipt.createdByPersonId, allReceiptPaymentMethods, loggedInUserReceiptPaymentMethods, isOtherPaymentMethod]);

  const addPaymentAction = React.useMemo(
    (): AutocompleteListItem[] =>
      loggedInUserId === receipt.createdByPersonId
        ? [
            {
              value: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Receipt.PaymentMethod),
              title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.EditPayment),
              subtitle: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.PaymentSettings),
              icon: IconDefinitionConstants.WPlus,
              form: (
                <AddPaymentMethodFormContainer
                  submitResultFormatter={(paymentMethod: WintSuperkollAPIModel.ReceiptPaymentMethod) => ({
                    id: paymentMethod.id,
                    value: paymentMethod.name,
                    data: paymentMethod,
                  })}
                />
              ),
              formIcon: IconDefinitionConstants.WIncome2,
              group: " ",
            },
          ]
        : [],
    [loggedInUserId]
  );

  return { receiptPaymentMethods, addPaymentAction };
}

export default usePaymentMethods;
